import { render, staticRenderFns } from "./mini-value-proposition.vue?vue&type=template&id=1fd86389&"
import script from "./mini-value-proposition.vue?vue&type=script&lang=js&"
export * from "./mini-value-proposition.vue?vue&type=script&lang=js&"
import style0 from "./mini-value-proposition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports